import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import authService from '../../Components/Login/auth.service'
import {
  ContainerPage,
  TitleOfPage,
  TitlePage1,
  TitlePage2,
  TitlePage3
} from '../../Components/Main'
import ProfileDireita from '../../Components/ProfileDireita'
import { NavDireita } from '../../Components/SideBar-right/SideBarDireita'
import SidebarMobile from '../../Components/SideBar-right/SidebarMobile'
import '../../styles/pages/MenuDireito/area.css'
import ModalCriar from './MenuDireito-Modal/ModalCadRestaurantes'
import Modal from './MenuDireito-Modal/ModalEdiRestaurantes'

function CadRestaurante() {
  const [areas, setAreas] = useState<any[]>([])
  const [modalInfo, setModalInfo] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  var user = authService.getCurrentUser()
  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_URL +
          '/api/v1/area/list/' +
          user[0].IdEmpresa +
          '/' +
          sessionStorage.IdUnidade
      )
      .then(response => {
        setAreas(response.data)
      })
  }, [])
  function handleToggleComplete(objetos = []) {
    setModalInfo(objetos)
    setModalOpen(true)
  }
  
  const [modalOpen, setModalOpen] = useState(false)
  //console.log(sessionStorage.uniSubUnidades)
  return (
    <div className="displayInteract">
      {modalOpen && (
        <Modal setOpenModal={setModalOpen} modalInfo={modalInfo} />
      )}

      <ContainerPage>
        <div id="containerHead1">
          <div className="logo" style={{ width: '200px', height: '80px' }} />
        </div>
        <div id="containerHead2">
          <TitleOfPage>
            <TitlePage1>
              {sessionStorage.uniRazaoSocial} / LOCAIS DE AUDITORIA
            </TitlePage1>
          </TitleOfPage>
          <div id="containerPesquisaModal">
            <input
              className="fnamePadrao"
              placeholder="Pesquisar..."
              type="text"
              id="fname1"
              name="fname"
              onChange={event => {
                setSearchTerm(event.target.value)
              }}
            />
            <ModalCriar />
          </div>
        </div>
        <div className="tabelaPadrao">
          <table>
            <thead>
              <th>
                <p className="ttlTbl">Nome</p>
              </th>
              <th>
                <p className="ttlTbl">Referência</p>
              </th>
              <th>
                <p className="ttlTbl">Observação</p>
              </th>
              <th>
                <p className="ttlTbl">Auditorias</p>
              </th>
              <th>
                <p className="ttlTbl">Documentos</p>
              </th>
              <th>Ativo</th>
            </thead>
            <tbody>
              {areas
                .filter(val => {
                  if (searchTerm === '' && val.IdLocalArea) {
                    return val
                  } else if (
                    val.locDescricao
                      .toLowerCase()
                      .includes(searchTerm.toLowerCase())
                  ) {
                    return val
                  }
                })
                .map(Restaurante => (
                  <tr key={Restaurante.IdLocalRestaurante}>
                    {/* <td className="tblCodArea">{Restaurante.IdLocalArea}</td> */}
                    <td onClick={() => handleToggleComplete(Restaurante)}>
                      {Restaurante.locDescricao}
                    </td>
                    <td onClick={() => handleToggleComplete(Restaurante)}>
                      {Restaurante.locReferencia}
                    </td>
                    <td onClick={() => handleToggleComplete(Restaurante)}>
                      {Restaurante.locObservacoes}
                    </td>
                    <td>
                      <Link to={`/RelatorioLocal/${Restaurante.IdLocalArea}`}>
                        <button className="verifObserv2">
                          <i className="fas fa-eye"></i>
                        </button>
                      </Link>
                    </td>
                    <td>
                      <Link to={`/DocumentosLocais/${Restaurante.IdLocalArea}`}>
                        <button className="verifObserv2">
                          <i className="fas fa-file"></i>
                        </button>
                      </Link>
                    </td>
                    <td onClick={() => handleToggleComplete(Restaurante)}>
                      <label className="container">
                        <input
                          type="checkbox"
                          defaultChecked={!!Restaurante.locStatus}
                          disabled
                        />
                        <span className="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </ContainerPage>
      <nav className="esconderFiltro">
        <ProfileDireita />
        <NavDireita />
        {user[0].gruDescricao === 'Humanit' ? (
          <SidebarMobile />
        ) : user[0].gruDescricao === 'Administrativo' ? (
          <SidebarMobile />
        ) : (
          <div></div>
        )}
      </nav>
    </div>
  )
}

export default CadRestaurante
